import React,{useState,useEffect,useRef} from "react";

  import { useRouteMatch,Switch, Route ,Link} from "react-router-dom";
import { useHistory,} from "react-router-dom";

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {X,Plus ,Star,BookmarkPlus,Phone,Check,Video,MonitorPlay,BookOpenCheck,
  TabletSmartphone,NotebookPen,BookDown,NotepadText,BookA,GalleryHorizontal,BadgePlus,Aperture,Blocks,CalendarCog} from 'lucide-react';
import ContentMenuCard from "../ContentMenuCard";
import LoadingButton from "../../../Loading/LoadingButton";

import contentNewfolder from "../../../contentImgs/blended-learning.png";
import Snackbar from "../../../../Snackbar";
import { createNewFolder } from "../../../../store/actions/CreateContent/FolderAPI/FolderAPIs";
import Loading from "../../../Loading/Loading";
import { createNewMilestone } from "../../../../store/actions/CreateContent/OrganizeAPI/SubCoursesAPIs";
const CreateMileStonePopup =({subCourseItem,menuOrder,sendBackItem,changeItemData,mileStoneItem,setopenAppDesignPopUp})=>{

     const dispatch = useDispatch();
     
        const [snackbarVisible, setSnackbarVisible] = useState(false);
        const [snackbarColor, setSnackbarColor] = useState("#958FDA");
        const [responseMessage, setResponseMessage] =useState("Something Went Wrong!!!");
      
      const showSnackbar = () => {
        setSnackbarVisible(true);
      };
     
      const hideSnackbar = () => {
        setSnackbarVisible(false);
      };


      const [mileStoneDescription ,setmileStoneDescription] =useState(mileStoneItem?.Description?mileStoneItem?.Description:"")
      const [mileStoneID ,setMilestoneID] =useState(mileStoneItem?.ID?mileStoneItem?.ID:"");
      const [mileStoneMenuOrder ,setFolderMenuOrder] =useState(mileStoneItem?.menuOrder?mileStoneItem?.menuOrder:menuOrder);
      const [showAddFolderEdit ,setShowAddFolderEdit] =useState(mileStoneItem?.ID?true:false)
       const [showAddFolderDetails ,setShowAddFolderDetails] =useState(mileStoneItem?.ID?true:false)
       
     const [FolderLook ,setFolderLook] =useState("")
           
           
            const [loader , setLoader] =useState({status:false});
      
       const [animate, setAnimate] = useState(false);
    const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
        {
          
          dispatch({type: "CURSOR",payload:true  });
      
          dispatch({type: "CURSORTEXT",payload:CursorText})
          dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
          dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
        }
         
        const handleMouseLeave = () => {
          
          dispatch({type: "CURSOR",payload:false})
      
          dispatch({type: "CURSORTEXT",payload:""})
      
          dispatch({type: "CURSORTEXTBG",payload:""})
          dispatch({type: "CURSORTEXTCOLOR",payload:""})
        
      
      }
        



      
       const token = useSelector((state)=>state?.course?.course?.token);
       const currentToken = useSelector((state)=>state?.user?.user?.token);
       const user_email = useSelector((state)=>state?.user?.user?.user_email
      );
      
      const postIdCourse = useSelector((state)=>state?.course?.course?.postId);
      
      const courseData = useSelector((state)=>state?.course?.course);
      
      const AppToken = useSelector((state)=>state?.app?.app?.AppToken);
     
             const appId = useSelector((state)=>state?.app?.app?.ID);
             const appAllottedToken = useSelector((state)=>state?.app?.app?.appAllottedToken);
             
       useEffect(() => {
         // Trigger the animation after a delay (e.g., 500ms)
         const timer = setTimeout(() => {
          setAnimate(true);  
        }, 100);
      
         return () => clearTimeout(timer); // Cleanup on unmount
       }, []);
      useEffect(()=>{
        // setCourseTitleData();
      },[])
      
      
const handleCreateFolder=(e)=>{



setLoader({status:true});
// console.log({Description:mileStoneDescription,
//     token:AppToken,courseId:postIdCourse ,postParent:subCourseItem?.ID ,userEmail:user_email?user_email:"",
//     currentToken:currentToken?currentToken:"",appToken:AppToken,
//     editType:'',postId:mileStoneID,menuOrder:mileStoneMenuOrder})
  const apiData = dispatch(createNewMilestone({Description:mileStoneDescription,
    token:AppToken,courseId:postIdCourse ,postParent:subCourseItem?.ID ,userEmail:user_email?user_email:"",
    currentToken:currentToken?currentToken:"",appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken,
    editType:'',postId:mileStoneID,menuOrder:mileStoneMenuOrder}));
  /* get response as Promise   */
  apiData.then(response => {
    if(response){

      // console.log(response)
      if(response?.mileStone){
    setResponseMessage(response?.message);
    setSnackbarColor("rgba(144, 202, 249,1)");
  
     
setLoader({status:false});

setSnackbarVisible(true);
setTimeout(()=>{
  
  setSnackbarVisible(false);
  sendBackItem(response?.mileStone);
  // console.log(response?.folder)
  setMilestoneID(response?.mileStone?.ID);
  setFolderMenuOrder(response?.mileStone?.menuOrder)
  setShowAddFolderDetails(true)
  setShowAddFolderEdit(true)
  setopenAppDesignPopUp()
},1000)
   }else{
    setResponseMessage("Something Went Wrong...");
      
    setSnackbarColor("#958FDA");
 
     
setLoader({status:false});

setSnackbarVisible(true);
setTimeout(()=>{
  
  setSnackbarVisible(false);
 
   
},3000)
   }
      
    // dispatch({
    //   type: "UPDATE_APP_TOKEN",
      
    //   payload:response?.course?.AppToken
    // });  
  //  console.log(response?.course);
 
   // 
   if(response?.logout){
    // pop up response?.logoutInfo
    //console.log(response?.logoutInfo)

    setResponseMessage("You are Logged Out!!!");
      
    setSnackbarColor("#958FDA");
 
     
setLoader({status:false});

setSnackbarVisible(true);
setTimeout(()=>{
  
  setSnackbarVisible(false);
 
   
},3000)
    setTimeout(()=>{
      dispatch({type:"LOGOUT"});

    },3000)
    
  }
/* resetting Login input Fields */

    }else{
      setResponseMessage("Something Went Wrong...");
      
      setSnackbarColor("#958FDA");
   
       
  setLoader({status:false});
  
  setSnackbarVisible(true);
  setTimeout(()=>{
    
    setSnackbarVisible(false);
   
     
  },3000)    }

  }).catch(error => {
 
    //popup of error Info
    setResponseMessage("Something Went Wrong...");
      
    setSnackbarColor("#958FDA");
 
     
setLoader({status:false});

setSnackbarVisible(true);
setTimeout(()=>{
  
  setSnackbarVisible(false);
 
   
},3000)
    console.error(error);
  });
 
  }
  
     
const handleUpdateFolder=(val)=>{
  let editType="";
if(val=="Description"){
 editType="Description";
}
  setLoader({status:true});

//   console.log({Description:mileStoneDescription,
//       token:AppToken,courseId:postIdCourse ,postParent:subCourseItem?.ID,userEmail:user_email?user_email:null,
//       currentToken:currentToken?currentToken:null,appToken:AppToken,
//       editType:editType,postId:mileStoneID,menuOrder:mileStoneMenuOrder})
      const apiData = dispatch(createNewMilestone({Description:mileStoneDescription,
      token:AppToken,courseId:postIdCourse ,postParent:subCourseItem?.ID,userEmail:user_email?user_email:null,
      currentToken:currentToken?currentToken:null,appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken,
      editType:editType,postId:mileStoneID,menuOrder:mileStoneMenuOrder}));
    /* get response as Promise   */
    apiData.then(response => {
      if(response){

        // console.log(response)
        if(response?.mileStone){
      setResponseMessage(response?.message);
      setSnackbarColor("rgba(144, 202, 249,1)");
    
       
  setLoader({status:false});
  
  setSnackbarVisible(true);
  setTimeout(()=>{
    
changeItemData(response?.mileStone?.ID,response?.mileStone);
    setSnackbarVisible(false);
    setmileStoneDescription(response?.mileStone?.Description);
    setMilestoneID(response?.mileStone?.ID);
    setShowAddFolderDetails(true)
    setShowAddFolderEdit(true)
    setopenAppDesignPopUp()
  },1000)
     }else{
      setResponseMessage("Something Went Wrong...");
        
      setSnackbarColor("#958FDA");
   
       
  setLoader({status:false});
  
  setSnackbarVisible(true);
  setTimeout(()=>{
    
    setSnackbarVisible(false);
   
     
  },3000)
     }
        
     
     if(response?.logout){
     
      setResponseMessage("You are Logged Out!!!");
        
      setSnackbarColor("#958FDA");
   
       
  setLoader({status:false});
  
  setSnackbarVisible(true);
  setTimeout(()=>{
    
    setSnackbarVisible(false);
   
     
  },3000)
      setTimeout(()=>{
        dispatch({type:"LOGOUT"});
  
      },3000)
      
    }
  /* resetting Login input Fields */
  
      }else{
        setResponseMessage("Something Went Wrong...");
        
        setSnackbarColor("#958FDA");
     
         
    setLoader({status:false});
    
    setSnackbarVisible(true);
    setTimeout(()=>{
      
      setSnackbarVisible(false);
     
       
    },3000)    }
  
    }).catch(error => {
   
      //popup of error Info
      setResponseMessage("Something Went Wrong...");
        
      setSnackbarColor("#958FDA");
   
       
  setLoader({status:false});
  
  setSnackbarVisible(true);
  setTimeout(()=>{
    
    setSnackbarVisible(false);
   
     
  },3000)
      console.error(error);
    });
   
    }



    return (<>
    
   {/* {<Loading  Load={loader?.status}/>} */}
     {snackbarVisible && (
        <Snackbar message={responseMessage} color={snackbarColor} onClose={hideSnackbar} />
      )}
    {FolderLook==""?<div className="" style={{alignContent:"center",textAlign:"center",marginTop:"0px",
     
     transition: 'transform 2s ease, opacity 1s ease',
   }}> <div className="userInfoLinerName"> <h2>{!mileStoneItem?.ID? mileStoneMenuOrder>1?"Create Milestone "+mileStoneMenuOrder+"- Add Description ":"Create Your First Milestone - Add Description ":"Edit MileStone "+mileStoneMenuOrder+" Description" }</h2></div>
      <div className="createFolderImgTop"> 
       <div style={{height:"120px",width:"120px",borderRadius:"50%",background:"#ffffff"}}>
      <img     src={contentNewfolder} 
       alt="selected Img"
  style={{cursor:"pointer",width:"60px",margin:"30px",marginTop:"30px"
   
  }}/> </div> </div> 
     <div className="createFolderImgTop">
     
<textarea onMouseEnter={handleMouseEnter}
    onMouseLeave={handleMouseLeave} className="createContentTextbox"  style= {{fontSize:"24px",width:"90%"}}
     placeholder="Add Details About This Milestone" type="text"
 rows={8} name="courseTitle" value={mileStoneDescription} onChange={(e)=>setmileStoneDescription(e.target.value)} />
   </div> 

   <div className="CreateCourseStepsOuterBottom" style={{padding:'15px',fontSize:'12px',marginBottom:'10px'}}>
   <div  >   </div>
 
   
   <button onMouseEnter={handleMouseEnter}
    onMouseLeave={handleMouseLeave} onClick={()=>{setopenAppDesignPopUp()}}  className="CreateCourseStepsOuterRightButtonBack"  type="submit"
    id="signupBtn"> Cancel </button>
{showAddFolderEdit?
<button onMouseEnter={handleMouseEnter}
    onMouseLeave={handleMouseLeave} onClick={()=>{handleUpdateFolder("Description")}} style={{width:"140px",height:"55px"}} className="CreateCourseStepsOuterRightButton"  type="submit"
    id="signupBtn"> {<LoadingButton  Load={loader?.status}/>} {loader?.status?"":"Update"} </button>:
<button onMouseEnter={handleMouseEnter}
    onMouseLeave={handleMouseLeave} onClick={()=>{handleCreateFolder()}} style={{width:"140px",height:"55px"}} className="CreateCourseStepsOuterRightButton"  type="submit"
    id="signupBtn"> {<LoadingButton  Load={loader?.status}/>} {loader?.status?"":"Click To Create"} </button>}
 </div> </div>
 
 :""}
       </>)
}
export default CreateMileStonePopup;

